export * from './object-edit.component';
export * from './object-edit.module';
